import React, { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { fetchBranches } from "../../store/slices/branchSlice";
import BranchCard from "./BranchCard";
import styles from "./BranchList.module.css";

export default function BranchList() {
  const dispatch = useAppDispatch();
  const { branches, isLoading, error } = useAppSelector((state) => state.branch);

  useEffect(() => {
    dispatch(fetchBranches());
  }, [dispatch]);

  if (isLoading) {
    return <div className={styles.loading}>Yükleniyor...</div>;
  }

  if (error) {
    return <div className={styles.error}>Hata: {error}</div>;
  }

  if (!branches || branches.length === 0) {
    return <div className={styles.empty}>Henüz şube eklenmemiş.</div>;
  }

  return (
    <div className={styles.branchList}>
      <h3 className={styles.title}>Şubeler</h3>
      <div className={styles.list}>
        {branches.map((branch) => (
          <BranchCard key={branch.id} branch={branch} />
        ))}
      </div>
    </div>
  );
}
